module.exports = __webpack_public_path__ + "static/media/p-light_3.48e82926.jpg";